import React from 'react';
import { Stack, Typography, Card, CardContent, Divider, CardHeader, Box, useMediaQuery } from '@mui/material';
import { useStaff } from '../../pages/Staff';
import { useManager } from '../../pages/Manager';
import { formatDate } from '../../services/functions';

const StaffSettlements = ({ manager }) => {
  const { application } = manager ? useManager() : useStaff();
  const isMobile = useMediaQuery('(max-width:600px)');
  if (!application) {
    return null;
  }

  return (
    <Stack direction="column" spacing={3} width="100%">
      <Stack direction={isMobile ? 'column' : 'row'} justifyContent="space-between" spacing={6} sx={isMobile ? { m: 4 } : { ml: 10, mr: 10 }}>
        <Card>
          <CardHeader title="Rozliczenia" />
          <CardContent>
            <Stack>
              <Typography variant="subtitle2">Kwota umowy (PLN)</Typography>
              <Typography sx={{ fontWeight: 'normal' }} variant="h5" mb={2}>{application.to_pay}</Typography>
            </Stack>
            <Stack>
              <Typography variant="subtitle2">Wypłacono (PLN)</Typography>
              <Typography sx={{ fontWeight: 'normal' }} variant="h5" mb={2}>{Number(application.payment_records.reduce((acc, payment) => Number(acc) + Number(payment.paid), 0))}</Typography>
            </Stack>
            <Stack>
              <Typography variant="subtitle2">Pozostało do wypłaty (PLN)</Typography>
              <Typography sx={{ fontWeight: 'normal' }} variant="h5" mb={2}>{Number(application.to_pay) - Number(application.payment_records.reduce((acc, payment) => Number(acc) + Number(payment.paid), 0))}</Typography>
            </Stack>
            <Stack>
              <Typography variant="subtitle2">Stawka dzienna (PLN)</Typography>
              <Typography sx={{ fontWeight: 'normal' }} variant="h5" mb={2}>{application.daily_rate}</Typography>
            </Stack>
            {application.season_year >= 2025 ? <Stack>
              <Typography variant="subtitle2">Stawka godzinowa styczeń-grudzień (PLN)</Typography>
              <Typography sx={{ fontWeight: 'normal' }} variant="h5" mb={2}>{application.hourly_rate}</Typography>
            </Stack>
              : <><Stack>
                <Typography variant="subtitle2">Stawka godzinowa styczeń-czerwiec (PLN)</Typography>
                <Typography sx={{ fontWeight: 'normal' }} variant="h5" mb={2}>{application.hourly_rate_summer}</Typography>
              </Stack>
              <Stack>
                <Typography variant="subtitle2">Stawka godzinowa lipiec-grudzień (PLN)</Typography>
                <Typography sx={{ fontWeight: 'normal' }} variant="h5" mb={2}>{application.hourly_rate_winter}</Typography>
              </Stack></>}
          </CardContent>
        </Card>

        <Card>
          <CardHeader title="Wypłacone transze" />
          <CardContent>
            <Stack>
              {
                application.payment_records.map((pr, key) => <Stack
                  key={key}
                  direction="row"
                  alignItems="center"
                  spacing={5}
                  p={1}
                  border={1}
                  borderColor="divider"
                  borderRadius={2}
                  mb={1}
                >
                  <Stack flex={1} p={1}>
                    <Typography variant="subtitle2">Kwota transzy</Typography>
                    <Typography sx={{ fontWeight: 'normal' }} variant="h5">{pr.paid}</Typography>
                  </Stack>
                  <Stack flex={1} p={1}>
                    <Typography variant="subtitle2">
                      Data dodania
                    </Typography>
                    <Typography sx={{ fontWeight: 'normal' }} variant="h5">
                      {formatDate(pr.record_date)}
                    </Typography>
                  </Stack>
                </Stack>
                )
              }
            </Stack>
          </CardContent>
        </Card>
        <Card width="120vh">
          <CardHeader title="Bonusy i dodatki (zawarte w umowie)" />
          <CardContent>
            <Stack alignItems="top">
              {application.bonus_payment_records.map((pr, key) => (
                <Stack
                  key={key}
                  direction="row"
                  alignItems="center"
                  spacing={5}
                  p={1}
                  border={1}
                  borderColor="divider"
                  borderRadius={2}
                  mb={1}
                >
                  <Stack p={1} minHeight={68}>
                    <Typography variant="subtitle2">
                      Bonus (PLN)
                    </Typography>
                    <Typography sx={{ fontWeight: 'normal' }} variant="h5">
                      {pr.paid}
                    </Typography>
                  </Stack>
                  <Stack flex={1} p={1} minHeight={68}>
                    <Typography variant="subtitle2">
                      Rodzaj
                    </Typography>
                    <Typography sx={{ fontWeight: 'normal' }} variant="h5">
                      {application.bonus_payment_records[key].type_display || 'Brak'}
                    </Typography>
                  </Stack>
                  <Stack flex={1} p={1} minHeight={68}>
                    <Typography variant="subtitle2">
                      Data dodania
                    </Typography>
                    <Typography sx={{ fontWeight: 'normal' }} variant="h5">
                      {formatDate(application.bonus_payment_records[key].record_date)}
                    </Typography>
                  </Stack>
                </Stack>
              ))}
            </Stack>
            <Stack mt={3}>
              <Typography variant="subtitle2">Dodatki (PLN)</Typography>
              <Typography sx={{ fontWeight: 'normal' }} variant="h5" mb={2}>{application.supplements}</Typography>
            </Stack>
            <Stack>
              <Typography variant="subtitle2">Dodatki z tytułu</Typography>
              <Typography sx={{ fontWeight: 'normal' }} variant="h5" mb={2}>{application.supplements_info}</Typography>
            </Stack>
          </CardContent>
        </Card>
      </Stack>
      {/* <Divider sx={{ my: 4 }}></Divider> */}
      {/* <Stack>
        <Stack justifyContent="center" alignItems="center">
          <Typography variant="subtitle2">Uwagi do rozliczeń</Typography>
          <Typography sx={{ fontWeight: 'normal' }} variant="h5" mb={2}>{application.settlements_notes}</Typography>
        </Stack>
      </Stack> */}
    </Stack>
  );
};

export default StaffSettlements;
